<template>
  <div style="height: 100vh">
    <v-skeleton-loader v-if="loading" class="mx-auto"  type="card-heading, divider, date-picker, table-row@6, actions"></v-skeleton-loader>
    <div v-else >
      <Navbar />
      <v-main class="grey lighten-3 ">
        <v-container fluid class="main">
          <div class="d-flex flex-column ma-3" style="position: absolute;right:0;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="" fab dark x-small color="primary" @click="changeFacetsBar()" v-bind="attrs" v-on="on">
                  <v-icon dark style="transform: rotate(90deg);">
                    {{ showFacets ? "mdi-backburger" : "mdi-forwardburger" }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ showFacets ? "Masquer" : "Afficher" }} les options de recherche</span>
            </v-tooltip>

            <v-tooltip bottom v-if="$store.state.filters.length">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mt-2" fab dark x-small color="primary" @click="removeAllFacets()" v-bind="attrs" v-on="on">
                  <v-icon dark>
                    mdi-trash-can-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Effacer tout</span>
            </v-tooltip>

          </div>
          <div class="ma-2 px-2">
            <!-- <Breadcrumbs /> -->
            <div class="d-flex flex-column px-7">
              <div id="facetbar" v-show="showFacets">
                <Facets v-if="facets" :key="rerender" :facetsValues="facets" :columnHeight="facetbarHeight - 0" />
              </div>
              <div v-if="showFacets" @mousedown="startDragging" id="separator"
                style="cursor:row-resize; padding-bottom: 10px; padding-top: 10px;" class="my-2">
                <hr class="solid">
              </div>
              <div id="result-content">
                <Results :total="totalCount" :hits="hits" :page.sync="page" :itemsPerPage.sync="itemsPerPage"
                  :sort.sync="sort" :tableHeight="showFacets ? resultTableHeight : 0" />
              </div>
            </div>
          </div>
        </v-container>

      </v-main>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/navigation/NavBar"
import Facets from "../components/Facets";
import Results from "../components/Results";
import { makeFetchRequest } from '../utils'
import { globalMixin } from '../mixins'
import { getFacetsConfiguration } from '../configs/helper'
import PreSelectedFacetsByBrand from '../configs/preSelectedFacetsByBrand.json';
import SearchFieldsByBrand from '../configs/searchFieldsByBrand.json';

export default {
  mixins: [globalMixin],
  components: {
    Navbar,
    Facets,
    Results
  },
  data: () => {
    return {
      brands: [     
        {  value: 'ucpa', resa_id: 0 },
        {  value: 'labalaguere', resa_id: 2 }
      ],
      collabRoute: false,
      totalCount: 0,
      hits: [],
      facets: null,
      lastFilters: {},
      page: 1,
      rerender: 0,
      itemsPerPage: 5,
      sort: null,
      canSearch: true, // To handle the reactive search when i don't wanna search,
      showFacets: true,
      isDragging: false,
      resultTableHeight: 300,
      facetbarHeight: 285,
      startY: 0,
      initialSearchPerformed: false, // Flag to track the initial search
    };
  },
  computed: {
    loading () {
      return this.$store.state.loading
    },
    query() {
      return this.$store.state.query;
    },
    filters() {
      return this.$store.state.filters;
    },
    brand() {
      return this.$store.state.activeBrand
    },
    pagination() {
      return {
        page: this.page,
        itemsPerPage: this.itemsPerPage,
      };
    }
  },
  methods: {
   async setOfferGuide() {

    const { lastname, firstname, uuid, date, iresaCode } = this.$route.query
    const savedGuides = this.$store.state.guidesToSet ? this.$store.state.guidesToSet : []
    let existGuides = [
     {
          fullName: `${lastname.trim()} ${firstname.trim()}`,
          uuid: uuid.trim()
      }, 
      ...savedGuides
    ]
    this.hits = this.hits.map(hit => {

        if(hit.dateDepart === parseInt(date) && hit.iresaCode === iresaCode) {
          if(!hit.guides) hit.guides = []

          hit.guides =existGuides
       
        }
        return hit
      })
   

      await this.$store.dispatch('setGuide', {date: parseInt(date), iresaCode: iresaCode, guides:existGuides})
      history.pushState(null, "", location.href.split("?")[0]);
      this.$store.commit('setGuides', [])
    },
    async search(query, filters, page, itemsPerPage, search_fields, sort = null, filterClause = null) {
      this.$store.commit("setLoader", true);

      // Get the context
      // console.log("SEARCH:", ((page - 1) * itemsPerPage), "-" , itemsPerPage, "|" ,"Query:", query , "|" ," Filters: " , JSON.stringify(filters), "|" ," Sort: " , JSON.stringify(sort))
      
      // Parse filters - not hidden facet  
      const facetsConfig = getFacetsConfiguration()
    
      const body = {
        start: ((page - 1) * itemsPerPage),
        limit: itemsPerPage,
        query: query ? query.trim() : "*",
        search_fields: search_fields,
        sort: sort,
        facets: facetsConfig,
        filters: filters,
        filterClause: filterClause
      }

      const response = await makeFetchRequest('/api/search', 'POST', body)

      if (response.success) {
        this.totalCount = response.data.count;
        this.hits = response.data.items;
        this.rerender ++
        this.facets = response.data.facets;
      } else {
        console.log("Error: ", response.data)
      }

      this.lastFilters = filters;
      this.initialSearchPerformed = true;
      this.$store.commit("setLoader", false);      
    },
    removeAllFacets() {
      this.$store.commit("resetFilter");
    },
    changeFacetsBar() {
      this.showFacets = !this.showFacets;
      // if(!this.showFacets){

      //   this.resultTableHeight = 0;
      // }
    },
    startDragging(event) {
      this.startY = event.clientY;

      this.isDragging = true;
    },
    stopDragging() {
      this.isDragging = false;
    },
    onMouseMove(event) {
      if (!this.isDragging) return;
      if (this.startY === 0) {
        this.startY = event.pageY;
        return;
      }

      // get difference between present position and last save position
      const delta = this.startY - event.pageY;

      // define min-heights
      if ((this.facetbarHeight - delta > 100) && (this.resultTableHeight + delta > 100)) {

        this.facetbarHeight = this.facetbarHeight - delta;
        this.resultTableHeight = this.resultTableHeight + delta;
      }

      // save position for next movement
      this.startY = event.pageY;
    },
    setPreselectedFacetsByBrand(isBrandChange = false) {
      if(isBrandChange) {
        this.removeAllFacets()
      }

      if (this.brand in PreSelectedFacetsByBrand &&  this.$store.state.filters.length === 0) {
        PreSelectedFacetsByBrand[this.brand].forEach(filter => {
          this.$store.commit('setFilter', filter);
        });
      }
    },
    getFilterClauseByBrand() {
      const filterClause = {
        'ucpa': [
          {
            bool: {
              should: [
                { range: { available_stock: { from: 1 } } },
                { term: { to_be_confirmed: true } },
                { term: { vendable: true } }
              ]
            }
          },
          { range: { date: { from: 'now' } } }
        ],
        'labalaguere': [
        { range: { dateDepart: { from: new Date().getTime() } } }
        ],
      }
      return this.brand in filterClause ? filterClause[this.brand] : []
    }
  },
  async created (){
    // Get Context
    const { partenaire, type_vente, allotement,  fata_id, rese_id, context_action } = this.$route.query;
    this.$store.commit('setContextInfo', {
      partner: partenaire ? partenaire : 1,
      sales_type: type_vente ? type_vente : 1,
      allotement: allotement ? allotement : 1,
      fata_id: fata_id ? fata_id : 0,
      rese_id: rese_id ? rese_id : 1, // Default for UCPA
      context_action: context_action ? context_action : "formcreate"
    });

    // Active brand should be set depending on rese_id query
    if (rese_id)
      this.$store.commit("setActiveBrand", rese_id === "2" ? 'labalaguere' : 'ucpa')
  },
  async mounted() {
    document.addEventListener('mouseup', this.stopDragging);
    document.addEventListener('mousemove', this.onMouseMove);

    this.setPreselectedFacetsByBrand(false);

    const filters = this.handleFilters(this.$store.state.filters);
    await this.search(this.$store.state.query, filters, this.page, this.itemsPerPage, null, this.sort ? this.sort.value : null, this.getFilterClauseByBrand());

    if(this.$route.query.context_action && this.$route.query.context_action === 'setguide') {
      this.collabRoute = true

      const marqueToSet = this.brands.find(brand => brand.resa_id === parseInt(this.$route.query.marque) )
      this.$store.state.contextInfo.rese_id = marqueToSet.resa_id
      this.$store.state.activeBrand = marqueToSet.value
      await this.setOfferGuide()
      this.collabRoute = false
    }
   
  },
  watch: {
    query(val) {
      // Reactive Search by search query
      this.canSearch = false; // To change
      this.page = 1;
      
      this.$store.commit('setSearchFields', SearchFieldsByBrand[this.brand]);

      // Possible cahnge lastFilters -> can use the handleFilters method now
      this.search(
        val,
        this.lastFilters,
        this.page,
        this.itemsPerPage,
        this.$store.state.searchFields,
        this.sort ? this.sort.value : null,
        this.getFilterClauseByBrand()
      );

      this.canSearch = true; // To change
    },
    filters(val) {
       // Skip the search on the first query change after mounting
      if (!this.initialSearchPerformed) return;

      if(this.collabRoute) return 

      this.canSearch = false; // To change
      // Reactive Search by facets
      const filters = this.handleFilters(val);
      this.page = 1;

      this.search(
        this.$store.state.query,
        filters,
        this.page,
        this.itemsPerPage,
        null,
        this.sort ? this.sort.value : null,
        this.getFilterClauseByBrand()
      );

      this.canSearch = true; // To change
    },
    pagination() {
      // Reactive Search by pagination
      if (this.canSearch) {
        this.search(
          this.$store.state.query,
          this.lastFilters,
          this.page,
          this.itemsPerPage,
          null,
          this.sort ? this.sort.value : null,
          this.getFilterClauseByBrand()
        );
      }
    },
    sort() {
      if (this.canSearch) {
        this.search(
          this.$store.state.query,
          this.lastFilters,
          this.page,
          this.itemsPerPage,
          null,
          this.sort.value
        );
      }
    },
    brand(){
      this.$store.state.loading = true
      this.canSearch = false; // To change
      // Prevent watch filters to make search request when store is changed
      this.initialSearchPerformed = false;
      this.setPreselectedFacetsByBrand(true);

      this.lastFilters = this.handleFilters(this.$store.state.filters);

      this.search(
          this.$store.state.query,
          this.lastFilters,
          this.page,
          this.itemsPerPage,
          null,
          this.sort ? this.sort.value : null,
          this.getFilterClauseByBrand()
        );
        this.canSearch = true; // To change
        this.$store.state.loading = false
    }
  },

  beforeDestroy() {
    document.removeEventListener('mouseup', this.stopDragging);
    document.removeEventListener('mousemove', this.onMouseMove);
  }
};
</script>

<style lang="scss">
.main {
  min-height: calc(100vh - 65px);
}

// When text is too big make the ... after the text
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 9vw;
}

hr.solid {
  border-top: 3px solid #bbb;
  border-radius: 15px;
}
</style>